// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"230":"confirmation","231":"checkout","690":"items","697":"donate"}[chunkId] || chunkId) + "-legacy." + {"230":"74f9cd70","231":"8a097ef3","338":"bd86afd3","690":"e390131b","697":"54d3f6f5"}[chunkId] + ".js";
};